var React = require('react');

function SDCRotateCW18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.58119,2.17152a7.717,7.717,0,0,1,7.64,2.702l.06518-1.99012a.5.5,0,0,1,.516-.48337l.50054.0163a.5.5,0,0,1,.48347.516v.00008l-.14865,4.543a.5.5,0,0,1-.51608.48339l-.037-.00259-4.52007-.48492a.5.5,0,0,1-.44382-.55048l0-.00006.05338-.497A.5.5,0,0,1,11.72458,5.98l2.66946.28608a6.23969,6.23969,0,1,0,.09574,6.84242.50619.50619,0,0,1,.69451-.17355l.02372.01515.40606.28433a.50251.50251,0,0,1,.14429.6751,7.75032,7.75032,0,1,1-8.17717-11.738Z","fill":"var(--iconFill, #464646)"}));
}

SDCRotateCW18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCRotateCW18N;

SDCRotateCW18N.default = SDCRotateCW18N;
